var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',[_c('span',{staticClass:"uk-icon",attrs:{"uk-icon":'ratio: 1; icon: '+_vm.icon}}),_vm._v(" "),_c('span',{staticClass:"uk-text-middle"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }